import { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ModalAlt from "../../components/modal/ModalAlt";
import { ERROR_MSG } from "../../constants/common";
import { GET_PLANT_BY_ID_ENDPOINT } from "../../constants/routes";
import request from "../../services/request";
import Container from "../../shared/Container";
import P from "../../shared/typography/P";
import BottomDrawer from "../../shared/ui/Drawer/BottomDrawer";
import ProjectForm from "../proposal/forms/ProjectForm";
import PropertyContent from "./PropertyContent";

const PropertyDetails = () => {
    const { propertyId } = useParams();
    const [propertyName, setPropertyName] = useState("");
    const [formData, setFormData] = useState({});
    const [dis, setDis] = useState(true);
    const fetchData = async () => {
        try {
            const endpoint = `${GET_PLANT_BY_ID_ENDPOINT}/${propertyId}`;
            const data = await request.authGet({ endpoint });
            setFormData(data?.data?.plant);
            setPropertyName(data?.data?.plant?.propertyName);
        } catch (err) {
            toast.error(typeof err === "string" ? err : ERROR_MSG);
        }
    };
    useEffect(() => {
        fetchData();
    }, [propertyId]);
    const updatePropertyDetailsHandler = async (values) => {
        const changedFields = {};
        const initial = {
            projectName: formData.propertyName,
            address: formData.siteAddress,
            city: formData.city,
            state: formData.state,
            pincode: formData.pincode,
            latitude: formData.latitude,
            longitude: formData.longitude,
        };

        Object.keys(initial).forEach((key) => {
            if (values[key] !== undefined && values[key] !== initial[key]) {
                changedFields[key] = values[key];
            }
        });

        if (Object.keys(changedFields).length === 0) {
            toast.error("No changes made to update");
            return;
        }

        try {
            const res = await request.authPut({
                endpoint: `${GET_PLANT_BY_ID_ENDPOINT}/update-plant-details/${propertyId}`,
                body: changedFields,
            });

            if (res?.data?.Plant?.propertyName) {
                setFormData((prev) => ({
                    ...prev,
                    propertyName: res.data.Plant.propertyName,
                    siteAddress: res.data.Plant.siteAddress,
                    city: res.data.Plant.city,
                    state: res.data.Plant.state,
                    pincode: res.data.Plant.pincode,
                    latitude: res.data.Plant.latitude,
                    longitude: res.data.Plant.longitude,
                }));
            }

            setDis((prev) => !prev);

            toast.success(
                typeof res?.message === "string"
                    ? res.message
                    : "Plant details updated successfully"
            );
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            setDis((prev) => !prev);
        }
    };

    const history = useHistory();

    return (
        <Container className="bg-blue-700 mx-0 px-0 pt-[10rem] min-w-full lg:container  lg:min-w-auto  min-h-screen lg:min-h-full lg:bg-white">
            <div
                className=" hidden lg:flex items-center gap-1 py-1"
                role="button"
                onClick={() => history.goBack()}
            >
                <P>
                    <GoArrowLeft />
                </P>
                <P> Dashboard</P>
            </div>
            <PropertyContent
                propertyId={propertyId}
                propertyName={propertyName}
                formData={formData}
                setDis={setDis}
                setFormData={setFormData}
            />
            <div className="hidden lg:block">
                <ModalAlt
                    isOpen={!dis}
                    contentClass={"bg-white"}
                    onClose={() => {
                        setDis((prev) => !prev);
                    }}
                    innerTimes={false}
                    topPadding={"20px"}
                >
                    <ProjectForm
                        initialValues={{
                            projectName: formData?.propertyName || "",
                            address: formData?.siteAddress || "",
                            city: formData?.city || "",
                            state: formData?.state || "",
                            pincode: formData?.pincode || "",
                            latitude: formData.latitude,
                            longitude: formData.longitude,
                        }}
                        onSubmit={updatePropertyDetailsHandler}
                    />
                </ModalAlt>
            </div>
            <div className="lg:hidden">
                <BottomDrawer
                    isOpen={!dis}
                    contentClass="min-h-[75vh] rounded-t-4 bg-white"
                    childrenClassName="bg-white"
                    className="z-[102]"
                    onClick={() => setDis((prev) => !prev)}
                >
                    <div className="bg-white  bottom-0">
                        <ProjectForm
                            initialValues={{
                                projectName: formData?.propertyName || "",
                                address: formData?.siteAddress || "",
                                city: formData?.city || "",
                                state: formData?.state || "",
                                pincode: formData?.pincode || "",
                                latitude: formData.latitude,
                                longitude: formData.longitude,
                            }}
                            onSubmit={updatePropertyDetailsHandler}
                        />
                    </div>
                </BottomDrawer>
            </div>
        </Container>
    );
};

export default PropertyDetails;
